import React from 'react';
import { ArrowUpRight, Flag, Gauge, Wrench } from 'lucide-react';
import { useI18n } from '../../../i18n';
import './KartLifeTeaser.css';

export default function KartLifeTeaser() {
  const { t } = useI18n();

  return (
    <section className="login-kartlife" aria-labelledby="login-kartlife-title">
      <div className="login-kartlife__mark" aria-hidden="true">
        <img
          src="/images/kartlife/league/amateur-sparring.webp"
          srcSet="/images/kartlife/league/amateur-sparring-640.webp 640w, /images/kartlife/league/amateur-sparring.webp 1254w"
          sizes="(min-width: 1024px) 65vw, 1px"
          alt=""
          loading="lazy"
          decoding="async"
          width="1254"
          height="1254"
        />
      </div>
      <div className="login-kartlife__copy">
        <div className="login-kartlife__brand">
          <img src="/images/kartlife/brand/kartlife-mark-kl-v2.png" alt="" width="52" height="36" loading="lazy" />
          <span>Kart<span>Life</span></span>
          <span className="login-kartlife__eyebrow">{t('Nowość w MyKart')}</span>
        </div>
        <h2 id="login-kartlife-title">{t('loginMobile.kartLifeHook')}</h2>
        <p className="login-kartlife__body">{t('Buduj gokarta, rozwijaj kierowcę i ścigaj się w lidze.')}</p>
        <button
          type="button"
          className="login-kartlife__cta"
          onClick={() => {
            document.getElementById('login-form')?.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' });
            document.getElementById('login-email')?.focus({ preventScroll: true });
          }}
        >
          {t('Zaloguj się i zagraj')} <span><ArrowUpRight size={19} aria-hidden="true" /></span>
        </button>
      </div>
      <ol className="login-kartlife__journey">
        {[[Wrench, 'build'], [Gauge, 'develop'], [Flag, 'race']].map(([Icon, key], index) => (
          <li key={key}>
            <span className="login-kartlife__step">0{index + 1}</span>
            <Icon size={17} strokeWidth={1.5} aria-hidden="true" />
            <span>{t('loginMobile.' + key)}</span>
          </li>
        ))}
      </ol>
    </section>
  );
}
